<template>
    <div>
        <div class="clearfix">
            <Form
                class="padding-right-15 margin-top-5"
                :label-width="130"
                ref="pickUpData"
                :model="formData"
            >
                <Row>
                    <Col span="24">
                        <FormItem
                            prop="dispatchDate"
                            :label="
                                $t('tms.ship.pick_up_date', {
                                    defaultValue: '取件日期',
                                })
                            "
                            :rules="required"
                        >
                            <Select
                                v-model="formData.dispatchDate"
                                @on-change="chooseDate"
                            >
                                <Option
                                    v-for="(item, index) in dispatchDateList"
                                    :key="index"
                                    :value="item.pickupDate"
                                    >{{ item.pickupDate }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem
                            prop="accessHour"
                            :label="
                                $t('tms.ship.time_interval', {
                                    defaultValue: '时间间隔',
                                })
                            "
                        >
                            <div>{{ accessHour }} （h）</div>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem
                            prop="startTime"
                            :label="
                                $t('tms.ship.start_time', {
                                    defaultValue: '开始时间',
                                })
                            "
                            :rules="required"
                        >
                            <TimePicker
                                v-model="formData.startTime"
                                format="HH:mm"
                                :steps="[1, 30]"
                                :disabled-hours="startHours"
                                hide-disabled-options
                                @on-change="chooseStartTime"
                                style="width: 100%"
                            />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem
                            prop="endTime"
                            :label="
                                $t('tms.ship.end_time', {
                                    defaultValue: '结束时间',
                                })
                            "
                            :rules="required"
                        >
                            <TimePicker
                                v-model="formData.endTime"
                                format="HH:mm"
                                :steps="[1, 30]"
                                :disabled-hours="endHours"
                                hide-disabled-options
                                @on-change="chooseEndTime"
                                style="width: 100%"
                            />
                        </FormItem>
                    </Col>
                    <!-- <Col span="24">
                        <FormItem prop='remark' label="备注" >
                            <Input v-model="formData.remark" type="textarea" :rows="4"/>
                        </FormItem>
                    </Col> -->
                </Row>
            </Form>
        </div>
        <!-- <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="editform"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
        /> -->
        <Spin fix v-if="loading"></Spin>
        <div class="text-right">
            <Button type="primary" @click="submit"
                >{{ $t("erp.b2c.sure", { defaultValue: "确定" }) }}
            </Button>
            <Button class="margin-left-10" @click="cancel">{{
                $t("erp.b2c.cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
    </div>
</template>

<script>
import {
    HttpPickReservation,
    HttpGetReservationDate,
} from "@/service/aftersales/aftersales";
export default {
    props: ["params"],
    data() {
        return {
            formData: {
                startTime: null,
                endTime: null,
            },
            allDateList: [],
            takeDate: [],
            takeTime: [],
            loading: false,
            required: [
                {
                    required: true,
                    message: this.$t("tms.ship.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            accessHour: 0,
            startHourEarly: 0, // 最早开始时间
            startHourLate: 23, // 最晚开始时间
            endHourLate: 23, // 最晚结束时间
            startHours: [], // 开始时间禁用
            endHours: [], // 结束时间禁用
            dispatchDateList: [], // 取件日期
        };
    },
    created() {
        this.getTime();
        //  // 获取时间下拉
        // this.loading = true;
        // HttpGetReservationDate({id:this.params}).then(res=>{
        //     this.allDateList = res.data.availabilityItems;
        //     this.takeDate = res.data.availabilityItems.map(item=>{
        //         return {
        //             value:item.pickupDate,
        //             label:item.pickupDate
        //         }
        //     })
        //     this.loading = false;
        // },err=>{
        //     this.$Message.error({content:err.message,duration: 10,closable: true});
        //     this.loading = false;
        // })
    },
    computed: {
        getBase() {
            return [
                {
                    label: this.$t("erp.aftersales.takedate", {
                        defaultValue: "取件日期",
                    }),
                    key: "reservationDate",
                    tag: "vSelect",
                    options: this.takeDate,
                    span: 24,
                    on: {
                        "on-change": (val) => {
                            this.allDateList.map((item) => {
                                if (val == item.pickupDate) {
                                    this.takeTime = item.availabilityTimes.map(
                                        (json) => {
                                            return {
                                                value:
                                                    json.readyTime +
                                                    "~" +
                                                    json.closeTime,
                                                label:
                                                    json.readyTime +
                                                    "~" +
                                                    json.closeTime,
                                            };
                                        }
                                    );
                                }
                            });
                        },
                    },
                },
                {
                    label: this.$t("erp.aftersales.taketime", {
                        defaultValue: "取件时间",
                    }),
                    key: "reservationTime",
                    tag: "vSelect",
                    options: this.takeTime,
                    span: 24,
                },
            ];
        },
    },
    methods: {
        async getTime() {
            this.loading = true;
            await HttpGetReservationDate({ id: this.params }).then(
                (res) => {
                    this.dispatchDateList = res.data.availabilityItems;
                    this.startHourEarly = res.data.openTime;
                    this.endHourLate = res.data.closeTime;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$Message.error(err.message);
                }
            );
        },
        chooseDate(val) {
            if (val) {
                this.formData.startTime = "";
                this.formData.endTime = "";
                const openEarlyTime = this.getHour(this.startHourEarly);
                const closeLateTime = this.getHour(this.endHourLate);
                const chooseArr = this.dispatchDateList.filter(
                    (item) => item.pickupDate == val
                )[0];
                this.startHourLate = chooseArr.cutOffTime;
                this.accessHour = chooseArr.accessHour;
                const openLateTime = this.getHour(chooseArr.cutOffTime);
                for (let i = 0; i < 24; i++) {
                    if (i < openEarlyTime || i > openLateTime) {
                        this.startHours.push(i);
                    }
                    if (i < openEarlyTime || i > closeLateTime) {
                        this.endHours.push(i);
                    }
                }
            }
        },
        chooseStartTime(val) {
            if (val) {
                if (this.compareTime(this.startHourEarly, val)) {
                    this.formData.startTime = this.startHourEarly;
                    this.$Message.error(`开始时间最早为${this.startHourEarly}`);
                    return;
                }
                if (this.compareTime(val, this.startHourLate)) {
                    this.formData.startTime = this.startHourEarly;
                    this.$Message.error(`开始时间最晚为${this.startHourLate}`);
                    return;
                }
            }
        },
        chooseEndTime(val) {
            if (val) {
                const time = this.accessHour * 3600;
                if (
                    this.timeToSec(val) -
                        this.timeToSec(this.formData.startTime) <
                    time
                ) {
                    const h =
                        Number(this.formData.startTime.split(":")[0]) +
                        Number(this.accessHour);
                    const m = this.formData.startTime.split(":")[1];
                    const s = this.formData.startTime.split(":")[2];
                    this.formData.endTime = `${h}:${m}:${s}`;
                    this.$Message.error(
                        this.$t("tms.ship.not_less_than", {
                            defaultValue: "开始时间与结束时间不得小于",
                        }) + `${this.accessHour}h`
                    );
                    return;
                }
            }
        },
        getHour(time) {
            if (time) {
                return Number(time.slice(0, 2));
            }
        },
        compareTime(time1, time2) {
            return this.timeToSec(time1) > this.timeToSec(time2);
        },
        timeToSec(time) {
            if (time) {
                let hour = time.split(":")[0];
                let min = time.split(":")[1];
                let sec = time.split(":")[2] || 0;
                const total =
                    Number(hour * 3600) + Number(min * 60) + Number(sec);
                return total;
            }
        },
        async submit() {
            const valid = await this.$refs.pickUpData.validate();
            if (!valid) {
                return;
            }
            const readyTime = this.formData.startTime.concat(":00");
            const closeTime = this.formData.endTime.concat(":00");
            const reservationTime = readyTime.concat("~", closeTime);
            this.loading = true;
            // HttpPickReservation({ id: this.params, ...this.formData})
            HttpPickReservation({
                id: this.params,
                reservationDate: this.formData.dispatchDate,
                reservationTime,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$emit("on-update");
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$Message.error({
                        content: err.message,
                        duration: 10,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
